export default function ProgressOverview({
  topics,
  topicProgress,
  progressLoading,
  handleExploreCLicked,
}) {
  return (
    <div className="row px-4 mt-3">
      {topics.map((topic, index) => {
        const progress = topicProgress[topic.id] || {
          marked: [],
          total: 0,
          percentage: 0,
        };

        const weightage = topic.weightage || 1;

        return (
          <div key={index} className="col-md-4 px-2 mb-4">
            <div
              onClick={() => handleExploreCLicked(topic.topicId)}
              style={{
                background: "#ffffff",
                borderRadius: "16px",
                padding: "16px",
                cursor: "pointer",
                border: "1px solid #eef2f5",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.08)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.05)";
              }}
            >
              {/* Topic Name */}
              <h5
                style={{
                  fontWeight: "600",
                  marginBottom: "10px",
                  color: "#2c3e50",
                }}
              >
                {topic.topicName}
              </h5>

              {/* Difficulty Bars */}
              <div
                style={{
                  marginTop: "6px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                {/* Label */}
                <span
                  style={{
                    fontSize: "0.75rem",
                    color: "#94a3b8",
                    fontWeight: 500,
                  }}
                >
                  Difficulty
                </span>

                {/* Bars */}
                <div style={{ display: "flex", gap: "4px" }}>
                  {[...Array(5)].map((_, i) => (
                    <div
                      key={i}
                      style={{
                        width: "14px",
                        height: "5px",
                        borderRadius: "4px",
                        background:
                          i < weightage
                            ? weightage <= 2
                              ? "#2ecc71" // easy (green)
                              : weightage === 3
                                ? "#f1c40f" // medium (yellow)
                                : "#e74c3c" // hard (red)
                            : "#e2e8f0",
                      }}
                    />
                  ))}
                </div>
              </div>

              {/* Progress */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "0.75rem",
                    color: "#64748b",
                  }}
                >
                  <span
                    style={{
                      fontSize: "0.75rem",
                      color: "#94a3b8",
                      fontWeight: 500,
                    }}
                  >
                    Progress
                  </span>
                  {progressLoading ? (
                    <>
                      {/* Skeleton Text */}
                      <div
                        style={{
                          width: "60px",
                          height: "10px",
                          background: "#e2e8f0",
                          borderRadius: "6px",
                          marginBottom: "6px",
                          animation: "pulse 1.2s infinite",
                        }}
                      />
                    </>
                  ) : (
                    <>
                      {/* Actual Progress */}
                      <div
                        style={{
                          display: "flex",
                          fontSize: "0.75rem",
                          color: "#64748b",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <span>{progress.percentage}%</span>

                          {progress.percentage === 100 && (
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#27ae60",
                                fontWeight: "bold",
                              }}
                            >
                              ✓
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                <div style={{ display: "flex", gap: "2px" }}>
                  {[...Array(10)].map((_, i) => (
                    <div
                      key={i}
                      style={{
                        flex: 1,
                        height: "4px",
                        borderRadius: "2px",
                        background:
                          i < progress.percentage / 10
                            ? progress.percentage <= 20
                              ? "#e74c3c" // red
                              : progress.percentage <= 40
                                ? "#e67e22" // orange
                                : progress.percentage <= 70
                                  ? "#f1c40f" // yellow
                                  : progress.percentage <= 90
                                    ? "#2ecc71" // light green
                                    : "#27ae60" // strong green
                            : "#e2e8f0",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
